/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AlertSettingModelFieldsFragment = { __typename?: 'AlertSettingModel', alert_setting_id: string, name: string, category?: string | null, notification_enabled: boolean, vitall_patient_id: string, reference_range_id: string, alert_parameters: Array<{ __typename?: 'AlertParameterModel', alert_parameter_id: string, code?: string | null, risk: string, is_custom: boolean, notification_enabled: boolean, lower_bound?: { __typename?: 'ParameterBoundary', inclusive: boolean, value: number } | null, upper_bound?: { __typename?: 'ParameterBoundary', inclusive: boolean, value: number } | null }>, recipients: Array<{ __typename?: 'AlertRecipientModel', user_id?: string | null, account_id?: string | null, name: string }> };

export type ListAlertSettingsQueryVariables = Types.Exact<{
  input: Types.ListAlertSettingsInput;
}>;


export type ListAlertSettingsQuery = { __typename?: 'Query', listAlertSettings: Array<{ __typename?: 'AlertSettingModel', alert_setting_id: string, name: string, category?: string | null, notification_enabled: boolean, vitall_patient_id: string, reference_range_id: string, alert_parameters: Array<{ __typename?: 'AlertParameterModel', alert_parameter_id: string, code?: string | null, risk: string, is_custom: boolean, notification_enabled: boolean, lower_bound?: { __typename?: 'ParameterBoundary', inclusive: boolean, value: number } | null, upper_bound?: { __typename?: 'ParameterBoundary', inclusive: boolean, value: number } | null }>, recipients: Array<{ __typename?: 'AlertRecipientModel', user_id?: string | null, account_id?: string | null, name: string }> }> };

export type UpdateAlertSettingMutationVariables = Types.Exact<{
  input: Types.UpsertAlertSettingInput;
}>;


export type UpdateAlertSettingMutation = { __typename?: 'Mutation', updateAlertSetting: { __typename?: 'AlertSettingModel', alert_setting_id: string, name: string, category?: string | null, notification_enabled: boolean, vitall_patient_id: string, reference_range_id: string, alert_parameters: Array<{ __typename?: 'AlertParameterModel', alert_parameter_id: string, code?: string | null, risk: string, is_custom: boolean, notification_enabled: boolean, lower_bound?: { __typename?: 'ParameterBoundary', inclusive: boolean, value: number } | null, upper_bound?: { __typename?: 'ParameterBoundary', inclusive: boolean, value: number } | null }>, recipients: Array<{ __typename?: 'AlertRecipientModel', user_id?: string | null, account_id?: string | null, name: string }> } };

export type DeleteAlertSettingMutationVariables = Types.Exact<{
  input: Types.DeleteAlertSettingInput;
}>;


export type DeleteAlertSettingMutation = { __typename?: 'Mutation', deleteAlertSetting: boolean };

export const AlertSettingModelFieldsFragmentDoc = gql`
    fragment AlertSettingModelFields on AlertSettingModel {
  alert_setting_id
  name
  category
  notification_enabled
  vitall_patient_id
  reference_range_id
  notification_enabled
  alert_parameters {
    alert_parameter_id
    code
    risk
    is_custom
    notification_enabled
    lower_bound {
      inclusive
      value
    }
    upper_bound {
      inclusive
      value
    }
  }
  recipients {
    user_id
    account_id
    name
  }
}
    `;
export const ListAlertSettingsDocument = gql`
    query listAlertSettings($input: ListAlertSettingsInput!) {
  listAlertSettings(input: $input) {
    ...AlertSettingModelFields
  }
}
    ${AlertSettingModelFieldsFragmentDoc}`;
export function useListAlertSettingsQuery(baseOptions: Apollo.QueryHookOptions<ListAlertSettingsQuery, ListAlertSettingsQueryVariables> & ({ variables: ListAlertSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>(ListAlertSettingsDocument, options);
      }
export function useListAlertSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>(ListAlertSettingsDocument, options);
        }
// @ts-ignore
export function useListAlertSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>;
export function useListAlertSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAlertSettingsQuery | undefined, ListAlertSettingsQueryVariables>;
export function useListAlertSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>(ListAlertSettingsDocument, options);
        }
export type ListAlertSettingsQueryHookResult = ReturnType<typeof useListAlertSettingsQuery>;
export type ListAlertSettingsLazyQueryHookResult = ReturnType<typeof useListAlertSettingsLazyQuery>;
export type ListAlertSettingsSuspenseQueryHookResult = ReturnType<typeof useListAlertSettingsSuspenseQuery>;
export type ListAlertSettingsQueryResult = Apollo.QueryResult<ListAlertSettingsQuery, ListAlertSettingsQueryVariables>;
export const UpdateAlertSettingDocument = gql`
    mutation updateAlertSetting($input: UpsertAlertSettingInput!) {
  updateAlertSetting(input: $input) {
    ...AlertSettingModelFields
  }
}
    ${AlertSettingModelFieldsFragmentDoc}`;
export type UpdateAlertSettingMutationFn = Apollo.MutationFunction<UpdateAlertSettingMutation, UpdateAlertSettingMutationVariables>;
export function useUpdateAlertSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlertSettingMutation, UpdateAlertSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlertSettingMutation, UpdateAlertSettingMutationVariables>(UpdateAlertSettingDocument, options);
      }
export type UpdateAlertSettingMutationHookResult = ReturnType<typeof useUpdateAlertSettingMutation>;
export type UpdateAlertSettingMutationResult = Apollo.MutationResult<UpdateAlertSettingMutation>;
export type UpdateAlertSettingMutationOptions = Apollo.BaseMutationOptions<UpdateAlertSettingMutation, UpdateAlertSettingMutationVariables>;
export const DeleteAlertSettingDocument = gql`
    mutation deleteAlertSetting($input: DeleteAlertSettingInput!) {
  deleteAlertSetting(input: $input)
}
    `;
export type DeleteAlertSettingMutationFn = Apollo.MutationFunction<DeleteAlertSettingMutation, DeleteAlertSettingMutationVariables>;
export function useDeleteAlertSettingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlertSettingMutation, DeleteAlertSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlertSettingMutation, DeleteAlertSettingMutationVariables>(DeleteAlertSettingDocument, options);
      }
export type DeleteAlertSettingMutationHookResult = ReturnType<typeof useDeleteAlertSettingMutation>;
export type DeleteAlertSettingMutationResult = Apollo.MutationResult<DeleteAlertSettingMutation>;
export type DeleteAlertSettingMutationOptions = Apollo.BaseMutationOptions<DeleteAlertSettingMutation, DeleteAlertSettingMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListAlertSettings = withQueryResponseHandler(useListAlertSettingsQuery);
export const useUpdateAlertSetting = withMutationResponseHandler(useUpdateAlertSettingMutation, "updateAlertSetting");
export const useDeleteAlertSetting = withMutationResponseHandler(useDeleteAlertSettingMutation, "deleteAlertSetting");